
import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";
import Card from "@/components/card/Card.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import LeftSideWideCard from "@/components/common/LeftSideWideCardNew.vue";

@Component({
  components: {
    Card,
    CardBodyItem,
    LeftSideWideCard,
  },
})
export default class CertificationCard extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, required: true }) readonly institution!: string;
  @Prop({ type: String, default: undefined }) readonly startDate?: string;
  @Prop({ type: String, default: undefined }) readonly endDate?: string;
     @Prop({ type: String, default: "" }) readonly isAddedBy?: string;

  get formattedStartDate() {
    return this.formatDate(this.startDate);
  }

get getBorder(): Object {
  return{
  "borderBlue": !this.isAddedBy,
  "borderGreen": this.isAddedBy,
  }
}

  get formattedEndDate() {
    return this.formatDate(this.endDate);
  }

  formatDate(dateString: string | undefined) {
   if (!dateString) {
      return "";
    }

    const date = moment(dateString);
    const finalDate = date.format("DD MMM YYYY");
    return finalDate;
  }
}
